import actions from "./actions"
import mutations from "./mutations"
import getters from "./getters"

const state = {
  topics: [],
  currentTopic: {
    data: null,
    error: null,
    loading: false,
  },
  currentTopicReactions : []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
